import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "47.084",
  width: "50",
  viewBox: "0 0 50 47.084",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25.54-.044v3.78c12.202 0 19.763 10.26 19.763 19.763 0 4.836-1.8 9.51-4.97 13.096v-6.89h-3.778V42.83H50v-3.78h-6.79c3.76-4.285 5.872-9.795 5.872-15.55 0-11.286-8.964-23.544-23.543-23.544zM0 5.95v3.78h6.51c-2.9 4.004-4.457 8.784-4.457 13.77 0 12.958 10.582 23.54 23.54 23.54h.055v-3.78c-10.907 0-19.763-8.854-19.763-19.76 0-4.222 1.334-8.276 3.78-11.65v7.22h3.78V5.95H0z"
  })]
});